import Excel from "exceljs";
import _ from "lodash";
import moment from "moment";
export default function extractRoster(e) {
  return new Promise((resolve, reject) => {
    const wb = new Excel.Workbook();
    const reader = new FileReader();
    const file = e.target.files[0];
    reader.readAsArrayBuffer(file);
    let tempObject = { roster: {}, additional_info: {} };
    let rosterData = [];
    let shopRosterData = {};
    let checkDuplicate = {};
    let error = [];
    let orders = 1;
    const ingoreType = [
      "ANL",
      "FAL",
      "NPSL",
      "PSL",
      "NPL",
      "BIL",
      "4/5SL",
      "COL",
      "MATL",
      "MARL",
      "OFF",
      "SHD",
    ];

    reader.onload = () => {
      const buffer = reader.result;
      wb.xlsx.load(buffer).then((workbook) => {
        const shopRoster = workbook.getWorksheet("shopRoster");
        shopRoster.eachRow((row, rowIndex) => {
          if (rowIndex > 1) {
            if (shopRosterData[row.values[1]] === undefined) {
              shopRosterData[row.values[1]] = {};
            }
            if (shopRosterData[row.values[1]][row.values[2]] === undefined) {
              shopRosterData[row.values[1]][row.values[2]] = {};
            }
            shopRosterData[row.values[1]][row.values[2]] = {
              startTime: moment(row.values[3], "HH:mm").format("HH:mm"),
              endTime: moment(row.values[4], "HH:mm").format("HH:mm"),
              lunch: `${row.values[5] ?? ""}`,
            };
          }
        });
        workbook.eachSheet((sheet) => {
          if (sheet.name.includes("Roster-")) {
            sheet.eachRow((row, rowIndex) => {
              let rowObject = { roster: {}, additional_info: {} };
              _.forEach(tempObject.roster, (value) => {
                rowObject.roster[value] = {};
              });

              row.eachCell((cell, colIndex) => {
                if (rowIndex === 1) {
                  let cellValue = cell.value;
                  if (cell.value.richText) {
                    cellValue = _.chain(cell.value.richText)
                      .map((richText) => richText.text)
                      .join("")
                      .value();
                  }
                  if (moment(cellValue).isValid()) {
                    tempObject.roster[colIndex] = moment(cell.value).format(
                      "YYYY-MM-DD"
                    );
                  } else if (cellValue.includes("#")) {
                    tempObject.additional_info[colIndex] = cellValue;
                  } else {
                    tempObject[colIndex] = cellValue;
                  }
                }
                if (rowIndex > 2) {
                  if (
                    tempObject.roster[colIndex] &&
                    moment(tempObject.roster[colIndex]).isValid()
                  ) {
                    let splitShopCode = [];
                    let remark = "";
                    if (typeof cell.value === "object" && cell.value.richText) {
                      splitShopCode = cell.value.richText[0].text.split("-");
                    } else {
                      splitShopCode = String(cell.value).split("-");
                    }
                    const shopCode = splitShopCode[0]?.replace(/\s/g, "");
                    const roster = ingoreType.includes(shopCode)
                      ? ""
                      : splitShopCode[1]?.replace(/\s/g, "") ?? "FULL";
                    remark = ingoreType.includes(shopCode)
                      ? typeof cell.value === "object"
                        ? cell.value.richText[1].text
                        : splitShopCode[1] ?? ""
                      : "";
                    rowObject.roster[`${tempObject.roster[colIndex]}`] = {
                      shopCode,
                      roster,
                      remark,
                      ...shopRosterData?.[shopCode]?.[roster],
                      orders,
                      style: JSON.stringify({
                        fill: cell.style.fill,
                        font: cell.style.font,
                      }),
                    };
                    if (!ingoreType.includes(shopCode)) {
                      if (
                        checkDuplicate[
                          `${shopCode}@${roster}@${tempObject.roster[colIndex]}`
                        ]
                      ) {
                        const errorMessage = `${rowObject["StaffCode"]} 與 ${
                          checkDuplicate[
                            `${shopCode}@${roster}@${tempObject.roster[colIndex]}`
                          ]
                        } 於 ${tempObject.roster[colIndex]} 重覆`;
                        error.push(errorMessage);
                      } else {
                        checkDuplicate[
                          `${shopCode}@${roster}@${tempObject.roster[colIndex]}`
                        ] = rowObject["StaffCode"];
                      }
                    }
                  } else if (tempObject.additional_info[colIndex]) {
                    if (cell.formula) {
                      rowObject.additional_info[
                        tempObject.additional_info[colIndex]
                      ] = { formula: cell.formula };
                    } else {
                      rowObject.additional_info[
                        tempObject.additional_info[colIndex]
                      ] = cell.value;
                    }
                  } else {
                    //B col
                    if (cell.col === 2) {
                      rowObject["base_location"] = cell.value;

                      if (cell.note) {
                        rowObject["shop_note"] = JSON.stringify(cell.note);
                      }
                      if (
                        cell.style.fill.fgColor?.argb ||
                        cell.style.fill.fgColor?.theme
                      ) {
                        rowObject["shop_color"] = JSON.stringify(
                          cell.style.fill.fgColor
                        );
                      }
                    } else if (cell.col === 3) {
                      //C col
                      if (cell.note) {
                        rowObject["name_note"] = JSON.stringify(cell.note);
                      }
                      if (
                        cell.style.fill.fgColor?.argb ||
                        cell.style.fill.fgColor?.theme
                      ) {
                        rowObject["name_color"] = JSON.stringify(
                          cell.style.fill.fgColor
                        );
                      }
                    }
                    rowObject[`${tempObject[colIndex]}`] = cell.value;
                  }
                }
              });
              if (rowIndex > 2) {
                rowObject.additional_info = JSON.stringify(
                  rowObject.additional_info
                );
                rosterData.push(rowObject);
                orders++;
              }
            });
          }
        });
        // const shopRoster = workbook.getWorksheet("shopRoster");
        // shopRoster.eachRow((row, rowIndex) => {
        //   if (rowIndex > 1) {
        //     if (shopRosterData[row.values[1]] === undefined) {
        //       shopRosterData[row.values[1]] = {};
        //     }
        //     if (shopRosterData[row.values[1]][row.values[2]] === undefined) {
        //       shopRosterData[row.values[1]][row.values[2]] = {};
        //     }
        //     shopRosterData[row.values[1]][row.values[2]] = {
        //       startTime: row.values[3],
        //       endTime: row.values[4],
        //     };
        //   }
        // });

        // const roster = workbook.getWorksheet("Roster");
        // roster.eachRow((row, rowIndex) => {
        //   let rowObject = { roster: {} };
        //   _.forEach(tempObject.roster, (value) => {
        //     rowObject.roster[value] = {};
        //   });
        //   row.eachCell((cell, colIndex) => {
        //     if (rowIndex === 1) {
        //       if (moment(cell.value).isValid()) {
        //         tempObject.roster[colIndex] = moment(cell.value).format(
        //           "YYYY-MM-DD"
        //         );
        //       } else {
        //         tempObject[colIndex] = cell.value;
        //       }
        //     }
        //     if (rowIndex > 2) {
        //       if (
        //         tempObject.roster[colIndex] &&
        //         moment(tempObject.roster[colIndex]).isValid()
        //       ) {
        //         let splitShopCode = [];
        //         let remark = "";
        //         if (typeof cell.value === "object") {
        //           splitShopCode = cell.value.richText[0].text.split("-");
        //           remark = cell.value.richText[1].text;
        //         } else {
        //           splitShopCode = cell.value.split("-");
        //         }
        //         const roster = splitShopCode[1]?.replace(/\s/g, "") ?? "FULL";
        //         const shopCode = splitShopCode[0]?.replace(/\s/g, "");

        //         rowObject.roster[`${tempObject.roster[colIndex]}`] = {
        //           shopCode,
        //           roster,
        //           remark,
        //           ...shopRosterData?.[shopCode]?.[roster],
        //         };
        //       } else {
        //         rowObject[`${tempObject[colIndex]}`] = cell.value;
        //       }
        //     }
        //   });
        //   if (rowIndex > 2) {
        //     rosterData.push(rowObject);
        //   }
        // });
        console.log("rosterData", rosterData);
        if (error.length > 0) {
          reject({ data: { rosterData, shopRosterData }, error });
        }
        resolve({ rosterData, shopRosterData });
      });
    };
  });
}
